export default __webpack_public_path__ + "static/media/Animals.ac4f7f43.svg";